/*
  ves-free-pack.js

  Opens the Free Starter Pack capture modal (snippets/ves-free-pack-modal.liquid)
  from any on-site "Free starter pack" link, instead of navigating away. The
  MailerLite embed inside handles the actual signup + delivery.

  Triggers (delegated, so it covers header / footer / mobile drawer / inline):
    - any element with [data-ves-freepack]
    - any link whose href points at the free-pack page (/pages/free-pack)

  Close: the × button, the backdrop, or Esc (native <dialog>).
*/
(function () {
  'use strict';

  function getModal() {
    return document.getElementById('ves-free-pack-modal');
  }

  function openModal() {
    var m = getModal();
    if (!m) return;
    if (typeof m.showModal === 'function') {
      if (!m.open) m.showModal();
    } else {
      m.setAttribute('open', '');
    }
    document.documentElement.classList.add('ves-fp-open');
    // Focus the email field once MailerLite has rendered the form.
    setTimeout(function () {
      var input = m.querySelector('input[type="email"], input[type="text"]');
      if (input) {
        try { input.focus(); } catch (e) {}
      }
    }, 60);
  }

  function closeModal() {
    var m = getModal();
    if (!m) return;
    if (m.open && typeof m.close === 'function') m.close();
    else m.removeAttribute('open');
    document.documentElement.classList.remove('ves-fp-open');
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    // Open: free-pack trigger links. The modal is the canonical on-site
    // capture, so plain /pages/free-pack links open it too, but:
    //  - modified clicks (cmd/ctrl/shift/alt, non-primary button) keep their
    //    native behavior (new tab etc.) instead of being swallowed;
    //  - if the modal isn't in the DOM for any reason, fall through to the
    //    normal navigation rather than dead-ending the click.
    var trigger = e.target.closest('[data-ves-freepack], a[href*="/pages/free-pack"]');
    if (trigger) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      if (!getModal()) return;
      e.preventDefault();
      openModal();
      return;
    }

    // Close: × button.
    if (e.target.closest('[data-ves-freepack-close]')) {
      e.preventDefault();
      closeModal();
      return;
    }

    // Close: click on the dialog backdrop (the dialog element itself, outside
    // its inner card).
    var m = getModal();
    if (m && m.open && e.target === m) {
      closeModal();
    }
  });

  // Native <dialog> fires `close` on Esc; keep the html flag in sync.
  document.addEventListener('close', function (e) {
    if (e.target && e.target.id === 'ves-free-pack-modal') {
      document.documentElement.classList.remove('ves-fp-open');
    }
  }, true);

  // Capture form (homepage block + this modal share snippets/ves-capture-block).
  // The form POSTs to MailerLite through a hidden iframe (no navigation); on
  // submit we swap the form out for the success / "check your inbox" message.
  // Native type=email + required validation gates the submit event (the form
  // intentionally has no novalidate), so this only runs for valid emails.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-ves-capture-form]')) return;

    // Re-entry guard: one POST per form. Rapid double-clicks/Enter before the
    // swap lands would otherwise fire duplicate subscribes.
    if (form.dataset.vesSubmitted === '1') {
      e.preventDefault();
      return;
    }
    form.dataset.vesSubmitted = '1';

    // Attach the visitor's quiz profile (if they took the quiz) as
    // MailerLite fields so leads arrive pre-segmented. Runs before the
    // browser serializes the form, so the hidden inputs are included.
    try {
      var qp = JSON.parse(localStorage.getItem('ves_quiz_profile') || 'null');
      if (qp) {
        [['quiz_profile', qp.q1], ['quiz_work', qp.q2], ['quiz_experience', qp.q3], ['quiz_pain', qp.q4], ['quiz_match', qp.match]].forEach(function (kv) {
          if (!kv[1]) return;
          var name = 'fields[' + kv[0] + ']';
          if (form.querySelector('[name="' + name + '"]')) return;
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = kv[1];
          form.appendChild(input);
        });
      }
    } catch (err) { /* enrichment is best-effort */ }
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;

    // Let the native POST to the hidden iframe proceed, then swap in the
    // confirmation. closest() keeps the lookup stable if the form ever gains
    // a wrapper; focusing the status box (a) lands keyboard users on it and
    // (b) pairs with its role=status announcement for screen readers.
    window.setTimeout(function () {
      var wrap = form.closest('.ves-try__content') || form.parentElement;
      var success = wrap && wrap.querySelector('[data-ves-capture-success]');
      form.hidden = true;
      if (success) {
        success.hidden = false;
        try { success.focus({ preventScroll: true }); } catch (err) {}
      }
    }, 150);
  });
})();
